export const environment = {
  apiKey: '',
  apiUrl: 'https://api.wemblesport.com',
  apiImagePath: 'https://api.wemblesport.com/',
};
